<template>
    <div class="container is-max-widescreen has-bg-white py-5">
        <Header/>
        <div class="columns">
            <div class="settings-section column has-background-white rounded-2 column p-0 is-3" >
                <aside class="menu pb-5">
                    <p class="title p-3 mb-3 pt-6 ml-3">
                        {{$t('settings')}}
                    </p>

                    <ul class="menu-list">
                        <router-link to="/brandSettings">
                            <li>
                                <a>
                                    {{$t('brand_settings')}} 
                                </a>
                            </li>
                        </router-link>
                        <router-link to="/vendorSettings">
                            <li>
                                <a>
                                    {{$t('vendor_settings')}} 
                                </a>
                            </li>
                        </router-link>
                        <router-link to="/languagePreference">
                            <li>
                                <a>
                                    {{$t('lang_preference')}} 
                                </a>
                            </li>
                        </router-link>
                    </ul>

                </aside>
            </div>
            <div class="main-section column has-background-white rounded-2 column pt-6 pl-5 is-9">
                <h1 class="title is-3 pl-2 is-flex">
                    
                    {{$t('vendor_settings')}}

                    <section class="b-tooltips ml-5">
                        <b-tooltip position="is-right" type="is-white" :triggers="['click']" :auto-close="['outside', 'escape']" multilined>
                            <i class="mdi mdi-alert-circle" style="color: #858C94; transform: scale(0.5);"></i>
                            <template v-slot:content>
                                 <h1 class="vendor-desc is-size-6 ml-2 w-100" v-html="$t('vendor_tooltip')"></h1>
                            </template>
                        </b-tooltip>
                    </section>
                </h1>




                <h1 class="is-block ml-2" style="color: #2C3A4B; font-size: 16px; font-weight: 600;" v-html="$t('select_brand')"></h1>

                <div class="is-flex is-align-items-center is-justify-content-space-between pl-2 mb-2">
                     <div class="flex-left is-flex is-align-items-center">
                        <b-dropdown v-model="selectedBrand" expanded aria-role="list" class="has-text-left w-100">
                            <template  #trigger>
                                <b-button class="is-multiline has-text-left is-justify-content-space-between w-100" icon-right="menu-down">
                                    <div class="is-size-7 has-text-weight-bold">{{selectedBrand.name | filterName}}</div>
                                </b-button>
                            </template>

                        

                            <b-dropdown-item v-for="brand in brands" :key="brand.brand_code" :value="brand" aria-role="listitem">
                                
                                <div class="media">
                                    <div class="media-content">
                                        <div class="is-size-7 has-text-weight-bold">{{brand.name | filterName}}</div>
                                    </div>
                                </div>
                            </b-dropdown-item>
                        </b-dropdown>

                        <h1 class="vendor-desc ml-2 w-100" v-html="$t('vendor_desc')"></h1>

                     </div>


                    <section class="b-tooltips">
                            <b-dropdown 
                                position="is-bottom-left"
                                aria-role="menu"
                                trap-focus
                                paddingless
                                class="custom-dropdown">

                                <template #trigger>
                                    <b-button icon-left="table" outlined type="is-primary" class="mx-2"></b-button>
                                </template>

                                <b-dropdown-item
                                    aria-role="menu-item"
                                    :focusable="false"
                                    custom
                                    type="is-primary"
                                    paddingless>
                                    <form action="" >
                                        <div class="modal-card" style="width:300px;">
                                            <div class="modal-card-body" position="is-top-right">
                                                    <b-field v-for="(column, index) in columnsTemplate"
                                                        :key="index"
                                                        class="control">
                                                            <div class="is-flex is-justify-content-space-between">
                                                                    <b-checkbox v-model="column.visible">
                                                                        {{ column.title }}
                                                                    </b-checkbox>
                                                            </div>                                                     
                                                    </b-field>
                                            </div>
                                        </div>
                                    </form>
                                </b-dropdown-item>
                            </b-dropdown>
                    </section>

                </div>


                <div class="p-2 table is-bordered is-striped is-narrow has-text-centered is-fullwidth">
                    <b-table
                        :data="filteredVendors"
                        bordered
                        :sticky-header="true"
                        >

                        <b-table-column field="status" :visible="columnsTemplate.find(row => row.field == 'status').visible" :label="$t('vendor_status')" v-slot="props">
                            <span>
                                {{ props.row.status }}
                            </span>
                        </b-table-column>

                        <b-table-column field="vendor_trade_name" :visible="columnsTemplate.find(row => row.field == 'vendor_trade_name').visible" :label="$t('vendor_trade_name')" v-slot="props">
                            <span class="has-text-centered">
                                {{ props.row.title }}
                            </span>
                        </b-table-column>

                        <b-table-column field="vendor_short_name" :visible="columnsTemplate.find(row => row.field == 'vendor_short_name').visible" :label="$t('vendor_short_name')" v-slot="props">
                            <span>
                                {{ props.row.alias }}
                            </span>
                        </b-table-column>

                        <b-table-column field="vendor_contact_name" :visible="columnsTemplate.find(row => row.field == 'vendor_contact_name').visible" :label="$t('vendor_contact_name')" v-slot="props">
                            <span>
                                {{ props.row.name }}
                            </span>
                        </b-table-column>

                        <b-table-column field="contact_mobile" :visible="columnsTemplate.find(row => row.field == 'contact_mobile').visible" :label="$t('contact_mobile')" v-slot="props">
                            <span>
                                {{ props.row.mobile}}
                            </span>
                        </b-table-column>

                        <b-table-column field="city" :visible="columnsTemplate.find(row => row.field == 'city').visible" :label="$t('city')" v-slot="props">
                            <span>
                                {{ props.row.city}}
                            </span>
                        </b-table-column>

                        <b-table-column field="district" :visible="columnsTemplate.find(row => row.field == 'district').visible" :label="$t('district')" v-slot="props">
                            <span>
                                {{ props.row.town}}
                            </span>
                        </b-table-column>

                        <b-table-column field="contact_tcnin" :visible="columnsTemplate.find(row => row.field == 'contact_tcnin').visible" :label="$t('contact_tcnin')" v-slot="props">
                            <span>
                                {{ props.row.tckn }}
                            </span>
                        </b-table-column>

                        <b-table-column field="mernis_number" :visible="columnsTemplate.find(row => row.field == 'mernis_number').visible" :label="$t('mernis_number')" v-slot="props">
                            <span>
                                {{ props.row.mersis}}
                            </span>
                        </b-table-column>

                        <template #empty>
                            <div  class="p-4" v-html="$t('no_vendors')"></div>
                        </template>

                    </b-table>


                </div>
                
            </div>
        </div>
    </div>
</template>

<script>

import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { mapActions,mapGetters } from 'vuex'
import Header from './Header'

export default {
    name:'Home',
    components: {
        Header,
        ValidationObserver,
        ValidationProvider
    },
    data() {

        return {
            selectedBrand:{},
            columnsTemplate: [
                { title: this.$t('vendor_status'), field: 'status', visible: true },
                { title: this.$t('vendor_trade_name'), field: 'vendor_trade_name', visible: true },
                { title: this.$t('vendor_short_name'), field: 'vendor_short_name', visible: true },
                { title: this.$t('vendor_contact_name'), field: 'vendor_contact_name', visible: true },
                { title: this.$t('contact_mobile'), field: 'contact_mobile', visible: true },
                { title: this.$t('city'),  field: 'city', visible: true },
                { title: this.$t('district'), field: 'district', visible: true },
                { title: this.$t('contact_tcnin'), field: 'contact_tcnin', visible: true },
                { title: this.$t('mernis_number'),  field: 'mernis_number',visible: true }
            ]
        }
    },
    computed:{
        ...mapGetters(['vendors', 'brands']),
        filteredVendors(){
            return this.vendors.filter(row => row.brand_code == this.selectedBrand.brand_code)
        }
    },
    mounted() {
        this.getBrands().then((response) => {
            console.log('--getBrands success response')
            console.log(response)
            if(response.status.code == '0'){
                if(response.content.result.length!==0){
                    console.log("girildi")
                    this.selectedBrand = response.content.result[0]
                   
                }
            }
        }).catch(e => {
            console.log('--getBrands Error')
            console.log(e)
        })
        this.getVendors()
    },
    methods: {
        ...mapActions(['getVendors', 'getBrands']),
    },
    created() {
        this.getVendors()
    },
    filters: {
        filterName:function(value){
            if ( value.length > 25 ) {
                return value.substring(0,25) + '...'
            } else {
                return value
            }
        }
    }
}
</script>

<style scoped>
    .settings-section{
        height: 100%;
        margin-right: 2rem;
    }
    .main-section{
        min-height: 35vh;
    }
    .vendor-desc{
        font-size: 0.81rem;
    }
    @media(max-width: 800px){
        .settings-section{
            margin-right: 0;
            margin-bottom: 2rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/VendorSettings.vue